// myprofilecertification.js
import React from 'react'
import './myprofilecertification.css';

const MyProfileCertification = ({ certdetails, handleCertificationDelete }) => {
    return (
        <div style={{ marginTop: '1.5rem' }}>
            {certdetails && certdetails.length > 0 ? (
                <div>
                    {certdetails.map((certification, index) => (
                        <div key={certification.certification_id} style={{ marginBottom: '1rem' }}>
                            <div>
                                <span>{certification.title}</span> 
                                <button 
                                    className='certdelbtn' 
                                    onClick={() => handleCertificationDelete(certification.certification_id)}
                                >
                                    <i className="fa-solid fa-trash"></i>
                                </button>
                                <span style={{ float: 'right', fontWeight: '300' }}>
                                    {new Date(certification.start_date).toLocaleDateString()} - 
                                    {certification.end_date 
                                        ? new Date(certification.end_date).toLocaleDateString()
                                        : 'No Expiry'}
                                </span>
                            </div>
                            <div style={{ marginBottom: '3rem' }}>
                                <p style={{ fontWeight: '300', margin: '0.5rem 0' }}>{certification.company}</p>
                                {certification.cert_link && (
                                    <p>
                                        <a 
                                            href={certification.cert_link.startsWith('http') 
                                                ? certification.cert_link 
                                                : `https://${certification.cert_link}`} 
                                            target="_blank" 
                                            rel="noopener noreferrer" 
                                            style={{ fontSize: 'small', color: '#0066CC', float: 'left', fontWeight: '300' }}
                                        >
                                            View Credentials &gt;
                                        </a>
                                    </p>
                                )}
                            </div>
                            {index !== certdetails.length - 1 && 
                                <hr style={{ marginBottom: '1rem', color: 'black', height: '1px', backgroundColor: 'black' }} />
                            }
                        </div>
                    ))}
                </div>
            ) : (
                <div>
                    <span>No Certification Added</span>
                </div>
            )}
        </div>
    )
}

export default MyProfileCertification